import { _ as _asyncToGenerator, a as _regeneratorRuntime } from '../../../dist/asyncToGenerator-c002e3ca.esm.js';
import { c as _createClass, b as _classCallCheck, _ as _inherits, a as _createSuper, d as _defineProperty, e as _assertThisInitialized } from '../../../dist/createClass-3115abc1.esm.js';
import { invariant, success, failure } from '@lens-protocol/shared-kernel';
import { _ as _wrapNativeSuper } from '../../../dist/wrapNativeSuper-76ffa30e.esm.js';
import { P as ProtocolCallUseCase } from '../../../dist/ProtocolCallUseCase-da9f73b0.esm.js';
export { F as FollowPolicyType, U as UpdateFollowPolicy } from '../../../dist/UpdateFollowPolicy-9a0265ed.esm.js';
import { D as DelegableProtocolCallUseCase } from '../../../dist/DelegableProtocolCallUseCase-68560579.esm.js';

var ActiveProfileLoader = /*#__PURE__*/function () {
  function ActiveProfileLoader(profileGateway, activeProfileGateway, activeProfilePresenter) {
    _classCallCheck(this, ActiveProfileLoader);
    this.profileGateway = profileGateway;
    this.activeProfileGateway = activeProfileGateway;
    this.activeProfilePresenter = activeProfilePresenter;
  }
  _createClass(ActiveProfileLoader, [{
    key: "loadActiveProfileByOwnerAddress",
    value: function () {
      var _loadActiveProfileByOwnerAddress = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(walletAddress, handle) {
        var activeProfile, profiles, profile;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return this.activeProfileGateway.getActiveProfile();
            case 2:
              activeProfile = _context.sent;
              if (!activeProfile) {
                _context.next = 7;
                break;
              }
              _context.next = 6;
              return this.activeProfilePresenter.presentActiveProfile(activeProfile);
            case 6:
              return _context.abrupt("return");
            case 7:
              _context.next = 9;
              return this.profileGateway.getAllProfilesByOwnerAddress(walletAddress);
            case 9:
              profiles = _context.sent;
              profile = handle ? profiles.find(function (p) {
                return p.handle === handle;
              }) : profiles[0];
              if (!profile) {
                _context.next = 14;
                break;
              }
              _context.next = 14;
              return this.storeAndPresent(profile);
            case 14:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function loadActiveProfileByOwnerAddress(_x, _x2) {
        return _loadActiveProfileByOwnerAddress.apply(this, arguments);
      }
      return loadActiveProfileByOwnerAddress;
    }()
  }, {
    key: "loadActiveProfileByHandle",
    value: function () {
      var _loadActiveProfileByHandle = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(handle) {
        var activeProfile, profile;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return this.activeProfileGateway.getActiveProfile();
            case 2:
              activeProfile = _context2.sent;
              if (!((activeProfile === null || activeProfile === void 0 ? void 0 : activeProfile.handle) === handle)) {
                _context2.next = 7;
                break;
              }
              _context2.next = 6;
              return this.activeProfilePresenter.presentActiveProfile(activeProfile);
            case 6:
              return _context2.abrupt("return");
            case 7:
              _context2.next = 9;
              return this.profileGateway.getProfileByHandle(handle);
            case 9:
              profile = _context2.sent;
              invariant(profile, 'Profile not found');
              _context2.next = 13;
              return this.storeAndPresent(profile);
            case 13:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function loadActiveProfileByHandle(_x3) {
        return _loadActiveProfileByHandle.apply(this, arguments);
      }
      return loadActiveProfileByHandle;
    }()
  }, {
    key: "storeAndPresent",
    value: function () {
      var _storeAndPresent = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(profile) {
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return this.activeProfileGateway.setActiveProfile(profile);
            case 2:
              _context3.next = 4;
              return this.activeProfilePresenter.presentActiveProfile(profile);
            case 4:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function storeAndPresent(_x4) {
        return _storeAndPresent.apply(this, arguments);
      }
      return storeAndPresent;
    }()
  }]);
  return ActiveProfileLoader;
}();

var DuplicatedHandleError = /*#__PURE__*/function (_Error) {
  _inherits(DuplicatedHandleError, _Error);
  var _super = _createSuper(DuplicatedHandleError);
  function DuplicatedHandleError(handle) {
    var _this;
    _classCallCheck(this, DuplicatedHandleError);
    _this = _super.call(this, "Handle \"".concat(handle, "\" is already taken"));
    _defineProperty(_assertThisInitialized(_this), "name", 'DuplicatedHandleError');
    return _this;
  }
  return _createClass(DuplicatedHandleError);
}( /*#__PURE__*/_wrapNativeSuper(Error));
var CreateProfile = /*#__PURE__*/function () {
  function CreateProfile(gateway, presenter, transactionQueue) {
    _classCallCheck(this, CreateProfile);
    this.gateway = gateway;
    this.presenter = presenter;
    this.transactionQueue = transactionQueue;
  }
  _createClass(CreateProfile, [{
    key: "create",
    value: function () {
      var _create = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(request) {
        var transactionResult, transaction;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return this.gateway.createProfileTransaction(request);
            case 2:
              transactionResult = _context.sent;
              if (!transactionResult.isFailure()) {
                _context.next = 6;
                break;
              }
              this.presenter.present(failure(transactionResult.error));
              return _context.abrupt("return");
            case 6:
              transaction = transactionResult.value;
              _context.next = 9;
              return this.transactionQueue.push(transaction);
            case 9:
              this.presenter.present(success());
            case 10:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function create(_x) {
        return _create.apply(this, arguments);
      }
      return create;
    }()
  }]);
  return CreateProfile;
}();

function isPaidFollowRequest(request) {
  return 'fee' in request && request.fee !== undefined;
}
function isProfileOwnerFollowRequest(request) {
  return 'followerProfileId' in request && request.followerProfileId !== undefined;
}
function isUnconstrainedFollowRequest(request) {
  return !isPaidFollowRequest(request) && !isProfileOwnerFollowRequest(request);
}
var FollowProfiles = /*#__PURE__*/function () {
  function FollowProfiles(tokenAvailability, signedFollow, signlessFollow, followProfilePresenter) {
    _classCallCheck(this, FollowProfiles);
    this.tokenAvailability = tokenAvailability;
    this.signedFollow = signedFollow;
    this.signlessFollow = signlessFollow;
    this.followProfilePresenter = followProfilePresenter;
  }
  _createClass(FollowProfiles, [{
    key: "execute",
    value: function () {
      var _execute = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(request) {
        var result;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (!isPaidFollowRequest(request)) {
                _context.next = 7;
                break;
              }
              _context.next = 3;
              return this.tokenAvailability.checkAvailability({
                amount: request.fee.amount,
                spender: request.fee.contractAddress
              });
            case 3:
              result = _context.sent;
              if (!result.isFailure()) {
                _context.next = 7;
                break;
              }
              this.followProfilePresenter.present(failure(result.error));
              return _context.abrupt("return");
            case 7:
              if (!isUnconstrainedFollowRequest(request)) {
                _context.next = 11;
                break;
              }
              _context.next = 10;
              return this.signlessFollow.execute(request);
            case 10:
              return _context.abrupt("return");
            case 11:
              _context.next = 13;
              return this.signedFollow.execute(request);
            case 13:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function execute(_x) {
        return _execute.apply(this, arguments);
      }
      return execute;
    }()
  }]);
  return FollowProfiles;
}();

var ProveNftOwnership = /*#__PURE__*/function () {
  function ProveNftOwnership(activeWallet, gateway, presenter) {
    _classCallCheck(this, ProveNftOwnership);
    this.activeWallet = activeWallet;
    this.gateway = gateway;
    this.presenter = presenter;
  }
  _createClass(ProveNftOwnership, [{
    key: "proveOwnership",
    value: function () {
      var _proveOwnership = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(request) {
        var challenge, wallet, signatureResult;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return this.gateway.createOwnershipChallenge(request);
            case 2:
              challenge = _context.sent;
              _context.next = 5;
              return this.activeWallet.requireActiveWallet();
            case 5:
              wallet = _context.sent;
              _context.next = 8;
              return wallet.signMessage(challenge.message);
            case 8:
              signatureResult = _context.sent;
              if (!signatureResult.isFailure()) {
                _context.next = 12;
                break;
              }
              this.presenter.present(failure(signatureResult.error));
              return _context.abrupt("return");
            case 12:
              this.presenter.present(success({
                id: challenge.id,
                signature: signatureResult.value
              }));
            case 13:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function proveOwnership(_x) {
        return _proveOwnership.apply(this, arguments);
      }
      return proveOwnership;
    }()
  }]);
  return ProveNftOwnership;
}();

var SwitchActiveProfile = /*#__PURE__*/function () {
  function SwitchActiveProfile(profileGateway, activeProfileGateway, activeProfilePresenter) {
    _classCallCheck(this, SwitchActiveProfile);
    this.profileGateway = profileGateway;
    this.activeProfileGateway = activeProfileGateway;
    this.activeProfilePresenter = activeProfilePresenter;
  }
  _createClass(SwitchActiveProfile, [{
    key: "switch",
    value: function () {
      var _switch2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(request) {
        var profile;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return this.profileGateway.getProfileById(request.profileId);
            case 2:
              profile = _context.sent;
              invariant(profile, 'Profile not found');
              _context.next = 6;
              return this.activeProfileGateway.setActiveProfile(profile);
            case 6:
              _context.next = 8;
              return this.activeProfilePresenter.presentActiveProfile(profile);
            case 8:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function _switch(_x) {
        return _switch2.apply(this, arguments);
      }
      return _switch;
    }()
  }]);
  return SwitchActiveProfile;
}();

var UnfollowProfile = /*#__PURE__*/function (_ProtocolCallUseCase) {
  _inherits(UnfollowProfile, _ProtocolCallUseCase);
  var _super = _createSuper(UnfollowProfile);
  function UnfollowProfile() {
    _classCallCheck(this, UnfollowProfile);
    return _super.apply(this, arguments);
  }
  return _createClass(UnfollowProfile);
}(ProtocolCallUseCase);

var UpdateDispatcherConfig = /*#__PURE__*/function (_ProtocolCallUseCase) {
  _inherits(UpdateDispatcherConfig, _ProtocolCallUseCase);
  var _super = _createSuper(UpdateDispatcherConfig);
  function UpdateDispatcherConfig() {
    _classCallCheck(this, UpdateDispatcherConfig);
    return _super.apply(this, arguments);
  }
  return _createClass(UpdateDispatcherConfig);
}(ProtocolCallUseCase);

var UpdateProfileDetails = /*#__PURE__*/function (_DelegableProtocolCal) {
  _inherits(UpdateProfileDetails, _DelegableProtocolCal);
  var _super = _createSuper(UpdateProfileDetails);
  function UpdateProfileDetails() {
    _classCallCheck(this, UpdateProfileDetails);
    return _super.apply(this, arguments);
  }
  return _createClass(UpdateProfileDetails);
}(DelegableProtocolCallUseCase);

var UpdateProfileImage = /*#__PURE__*/function (_DelegableProtocolCal) {
  _inherits(UpdateProfileImage, _DelegableProtocolCal);
  var _super = _createSuper(UpdateProfileImage);
  function UpdateProfileImage() {
    _classCallCheck(this, UpdateProfileImage);
    return _super.apply(this, arguments);
  }
  return _createClass(UpdateProfileImage);
}(DelegableProtocolCallUseCase);

export { ActiveProfileLoader, CreateProfile, DuplicatedHandleError, FollowProfiles, ProveNftOwnership, SwitchActiveProfile, UnfollowProfile, UpdateDispatcherConfig, UpdateProfileDetails, UpdateProfileImage, isPaidFollowRequest, isProfileOwnerFollowRequest, isUnconstrainedFollowRequest };
